<template>
    <div class="viewBOSTF">
        <div class="modal-conteudo m-2">
            <div id="divImprimir">
                <!--<h3 class="bold txtApp" v-html="dados.nmTitulo"></h3>-->
                <div class="row mb-2">
                    <div class="col-md-12">
                        <p class="txt-p txt-w-7 txt-size-16"> {{dados.dsCodigo}}</p>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h4 class="txtApp">Data:</h4>
                        <template v-if="dados.dtPublicacao == null || dados.dtPublicacao == ''">
                            <p class="regular">...</p>
                        </template>
                        <template v-else>
                            <p class="regular" v-html="dados.dtPublicacao"></p>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h4 class="txtApp">Texto:</h4>
                        <template v-if="dados.dsTexto == null || dados.dsTexto == ''">
                            <p class="regular">...</p>
                        </template>
                        <template v-else>
                            <p class="regular" v-html="dados.dsTexto"></p>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer pb-0 mt-4 d-flex justify-content-end">
            <!--<AdicionarBiblioteca v-if="exibeBiblioteca" :id="dados.idBoletimStf.toString()" :tipo="tpConteudo" :cdConteudo="cdConteudo"></AdicionarBiblioteca>-->

            <a :href="dados.urlLink" class="btn btn-blue txt-size-14" target="_blank" v-if="dados.urlLink">
                <i class="fas fa-external-link-alt"></i> Acessar Boletim
            </a>
            
            <button class="btn btn-blue txt-size-14" @click="imprimir">
                <i class="fas fa-print"></i> Imprimir
            </button>
        </div>
    </div>
</template>

<script>
    //import AdicionarBiblioteca from '../AdicionarBiblioteca'
    
    export default {
        name: 'viewBOSTF',
        components: { /*AdicionarBiblioteca*/ },
        data: function () {
            return {
                exibeBiblioteca: true,
                tpConteudo: 'Pesquisa',
                cdConteudo: 'BOSTF',
            }
        },
        props: {
            dados: Object,
        },
        methods: {

            imprimir() {
                var conteudo = document.getElementById('divImprimir').innerHTML,
                    tela_impressao = window.open('about:blank');

                tela_impressao.document.write(conteudo);
                tela_impressao.window.print();
                tela_impressao.window.close();
            },
        },
        mounted: function () {
        },
        watch: {
            dados: {
                handler() {
                },
                deep: true
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
   
</style>

